






















































































import Vue from "vue";

export default Vue.extend({
  name: "Welcome",

  data: () => ({
    //
  }),
  methods: {
    getAgeOfBusiness() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const age = currentYear - 2012;
      console.log(age);
      return age;
    }
  }
});
